import React from 'react';
import { motion } from 'framer-motion';
import { Question, MetabolicType } from '../lib/constants';
import { ProgressBar } from './ProgressBar';
interface QuizQuestionProps {
  question: Question;
  currentIndex: number;
  totalQuestions: number;
  onAnswer: (type: MetabolicType) => void;
}
export function QuizQuestion({
  question,
  currentIndex,
  totalQuestions,
  onAnswer
}: QuizQuestionProps) {
  return <motion.div key={question.id} initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} className="flex flex-col px-5 py-5 min-h-[100dvh] bg-white max-w-md mx-auto shadow-xl overflow-y-auto hide-scrollbar" data-id="element-261">
      <div data-id="element-262">
        <ProgressBar current={currentIndex + 1} total={totalQuestions} label={`Pregunta ${currentIndex + 1} de ${totalQuestions}`} data-id="element-263" />
        <p className="text-xs text-gray-400 text-center mt-1" data-id="element-264">
          Este test tarda menos de 2 minutos.
        </p>
      </div>

      <div className="mt-6" data-id="element-265">
        {currentIndex === 0 && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} className="bg-blue-50 border border-blue-100 rounded-xl p-3 mb-3" data-id="element-266">
            <p className="text-sm text-secondary font-medium" data-id="element-267">
              Este test analiza tus hábitos y patrones de energía para
              identificar tu tipo metabólico.
            </p>
          </motion.div>}

        <h2 className="text-xl sm:text-2xl font-bold text-dark mb-4 leading-snug" data-id="element-268">
          {question.question}
        </h2>

        <div className="flex flex-col gap-2.5" data-id="element-269">
          {question.options.map((option, idx) => <motion.button key={idx} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={() => onAnswer(option.type)} className="w-full text-left px-4 py-3 rounded-xl border-2 border-gray-100 bg-white shadow-sm hover:border-primary hover:bg-green-50 transition-all group" data-id="element-270">
              <span className="text-sm sm:text-base font-medium text-gray-700 group-hover:text-primary transition-colors" data-id="element-271">
                {option.text}
              </span>
            </motion.button>)}
        </div>
      </div>
    </motion.div>;
}